/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {Type} from 'class-transformer';
import {Dictionary} from 'app/entities/dictionary.entity';
import {SwitchCheckboxCollection, SwitchRadioCollection} from 'app/entities/switchCollection.entity';
import {FormElementType} from 'app/entities/enums';

export class FormElementSelect extends FormElement {
  type: FormElementType = 'select';

  @Type(() => FormElementSelectConfiguration)
  configuration?: FormElementSelectConfiguration = new FormElementSelectConfiguration();
}

export class FormElementSelectConfiguration extends FormElementConfiguration {
  dictionaryCode?: string = null;
  multiple? = false;
  ownVariants? = false;
  search? = false;
  minSelected?: number = null;
  maxSelected?: number = null;
  searchPlaceholder?: string = null;
  notFoundText?: string = null;
  searchHint?: string = null;
  searchCustomRequest?: string = null;

  showMarkCheck? = false; // add to api

  dependantOn?: string[] = [];
  clearable= true;

  @Type(() => Dictionary)
  dictionaryList?: Dictionary[] = [];

  getListCollection?() {
    if (this.multiple) {
      return new SwitchCheckboxCollection(this.dictionaryList.map((item) => item.getSwitchItem()));
    } else {
      return new SwitchRadioCollection(this.dictionaryList.map((item) => item.getSwitchItem()));
    }
  }
}
